import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  // useContext,
} from "react";
import ReactDOM from "react-dom";
import grapesjs from "grapesjs";
// import "grapesjs/dist/css/grapes.min.css?v1.2.6";
import "./grapes.scss";
import "./Notes.scss";
import { UploadIcon, TrashIcon, BorderNoneIcon } from "@radix-ui/react-icons";
import DialogNotePublished from "../dialogs/DialogNotePublished";
import GrapesCardSelectionDialog from "./GrapesCardSelectionDialog";
import DialogSaveTemplate from "../dialogs/DialogSaveTemplate"; // Import your dialog component
import AlertDialogCustom from "../AlertDialog";
import { parse } from "papaparse";
import axios from "axios";
import {
  Button,
  Heading,
  Separator,
  Flex,
  IconButton,
  Toast,
  DropdownMenu,
  Tag,
  Toggle,
} from "blocksin-system";
// import NotesContext from "../contexts/NotesContext";

const Notes = ({
  title,
  id,
  currentUser,
  selectedOrgProjects,
  projectTitle,
  // onIdChange,
  projectId,
}) => {
  const serverUrl = process.env.REACT_APP_SERVER_URL;
  // const { noteId, setNoteId } = useContext(NotesContext);
  const [publicTemplates, setPublicTemplates] = useState([]);
  const [orgTemplates, setOrgTemplates] = useState([]);
  const [iframeBodyHeight, setIframeBodyHeight] = useState(700);
  //
  //
  //
  // const [iframeUrl, setIframeUrl] = useState("");
  //
  //
  //
  //
  const editorRef = useRef(null);
  const editorInstance = useRef(null);
  //
  const [showToast, setShowToast] = useState(false);
  const [showFailedSaveToast, setShowFailedSaveToast] = useState(false);
  const [showToastTemplate, setShowToastTemplate] = useState(false);
  const [showToastPublished, setShowToastPublished] = useState(false);
  //
  const [hasContent, setHasContent] = useState(false);
  const [isNoteSaved, setIsNoteSaved] = useState(false);
  const [isNotePublished, setIsNotePublished] = useState(false);
  const [showAlertClearNotesDialog, setShowAlertClearNotesDialog] =
    useState(false);

  const [showDialog, setShowDialog] = useState(false);
  const extendedCardRef = useRef(null);
  const [showSaveTemplateButton, setShowSaveTemplateButton] = useState(false);
  const [isSaveTemplateDialogOpen, setIsSaveTemplateDialogOpen] =
    useState(false);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  // Function to open the dialog
  //

  const [showPreview, setShowPreview] = useState(false);

  const handlePublish = () => {
    setShowDialog(true);
  };

  const onPublish = async (isPublic, showAPI, isPublished, isDraft = false) => {
    setShowDialog(false);
    setShowPreview(true);

    if (!noteId) {
      console.error("Note ID is missing, cannot publish.");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("Token is missing, authorization required to publish.");
      return;
    }

    const publishData = {
      isPublic,
      showAPI,
      isPublished: isDraft ? false : isPublished, // Use the isDraft flag to determine the isPublished status
    };

    try {
      const response = await fetch(
        `${serverUrl}/api/notes/update-publish-status/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(publishData),
        }
      );

      const responseData = await response.json();
      if (response.ok) {
        console.log("Note published successfully", responseData);
        setIsNotePublished(true); // Update the state to reflect the published status
        setShowToastPublished(true);
      } else {
        console.error("Failed to publish note:", responseData.message);
      }
    } catch (error) {
      console.error("Error publishing note:", error);
    }
  };
  useEffect(() => {
    organizationRef.current = currentUser?.organisation?.name;
    cardTitleRef.current = title;
    projectTitleRef.current = projectTitle;
  }, [title, projectTitle, currentUser?.organisation?.name]);

  const organizationRef = useRef(currentUser?.organisation?.name);
  const projectTitleRef = useRef(projectTitle);
  const cardTitleRef = useRef(title);

  const initializeEditorWithDefaultContent = () => {
    // Only add default content if the editor is empty
    if (editorInstance.current.getComponents().length === 0) {
      editorInstance.current.addComponents({
        type: "text",
        components: {
          type: "textnode",
          content: "Start writing your first component docs!",
        },
        classes: "H1",
      });
    }

    setIsNoteSaved(false);
    setHasContent(true);
  };

  const [noteId, setNoteId] = useState();

  const onToggleGrid = (checked) => {
    console.log("Toggle clicked, checked:", checked);
    const iframe = editorRef.current?.querySelector(".gjs-frame");
    if (iframe && iframe.contentWindow) {
      const body = iframe.contentWindow.document.body;
      body.classList.toggle("show-borders", checked);
    }
  };
  //
  //
  //
  //
  const [showComponentToolbar, setShowComponentToolbar] = useState(false);

  //
  const initializeEditor = useCallback(
    (grapesContent) => {
      if (!editorRef.current) {
        console.error("Editor ref is not attached to a DOM element");
        return;
      }

      if (!editorInstance.current) {
        editorInstance.current = grapesjs.init({
          container: editorRef.current,

          fromElement: true,
          components: grapesContent.components || [],
          style: grapesContent.styles || [],
          // Disable default panels and settings
          panels: { defaults: [] },

          // Define your custom commands here
          commands: {
            defaults: [
              // ...other commands
              {
                id: "insert-code",
                run(editor, sender) {
                  // Command logic here
                },
              },
            ],
          },

          // Define your custom RTE actions here
          rte: {
            actions: [
              // ...existing actions
              {
                icon: "<svg>...</svg>", // Replace with your icon SVG
                title: "Code",
                command: "insert-code", // Command to run when the button is clicked
              },
            ],
          },

          blockManager: {
            appendTo: "#blocks",
            blocks: [
              {
                id: "h1",
                label:
                  `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75432 2.0502C8.50579 2.0502 8.30432 2.25167 8.30432 2.5002C8.30432 2.74873 8.50579 2.9502 8.75432 2.9502H9.94997V7.05004H5.04997V2.9502H6.25432C6.50285 2.9502 6.70432 2.74873 6.70432 2.5002C6.70432 2.25167 6.50285 2.0502 6.25432 2.0502H2.75432C2.50579 2.0502 2.30432 2.25167 2.30432 2.5002C2.30432 2.74873 2.50579 2.9502 2.75432 2.9502H3.94997V12.0502H2.75432C2.50579 12.0502 2.30432 12.2517 2.30432 12.5002C2.30432 12.7487 2.50579 12.9502 2.75432 12.9502H6.25432C6.50285 12.9502 6.70432 12.7487 6.70432 12.5002C6.70432 12.2517 6.50285 12.0502 6.25432 12.0502H5.04997V7.95004H9.94997V12.0502H8.75432C8.50579 12.0502 8.30432 12.2517 8.30432 12.5002C8.30432 12.7487 8.50579 12.9502 8.75432 12.9502H12.2543C12.5028 12.9502 12.7043 12.7487 12.7043 12.5002C12.7043 12.2517 12.5028 12.0502 12.2543 12.0502H11.05V2.9502H12.2543C12.5028 2.9502 12.7043 2.74873 12.7043 2.5002C12.7043 2.25167 12.5028 2.0502 12.2543 2.0502H8.75432Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>` +
                  "1",
                content:
                  '<div data-gjs-type="text" class="H1">Heading level 1 here</div>',
              },
              {
                id: "h2",
                label:
                  `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75432 2.0502C8.50579 2.0502 8.30432 2.25167 8.30432 2.5002C8.30432 2.74873 8.50579 2.9502 8.75432 2.9502H9.94997V7.05004H5.04997V2.9502H6.25432C6.50285 2.9502 6.70432 2.74873 6.70432 2.5002C6.70432 2.25167 6.50285 2.0502 6.25432 2.0502H2.75432C2.50579 2.0502 2.30432 2.25167 2.30432 2.5002C2.30432 2.74873 2.50579 2.9502 2.75432 2.9502H3.94997V12.0502H2.75432C2.50579 12.0502 2.30432 12.2517 2.30432 12.5002C2.30432 12.7487 2.50579 12.9502 2.75432 12.9502H6.25432C6.50285 12.9502 6.70432 12.7487 6.70432 12.5002C6.70432 12.2517 6.50285 12.0502 6.25432 12.0502H5.04997V7.95004H9.94997V12.0502H8.75432C8.50579 12.0502 8.30432 12.2517 8.30432 12.5002C8.30432 12.7487 8.50579 12.9502 8.75432 12.9502H12.2543C12.5028 12.9502 12.7043 12.7487 12.7043 12.5002C12.7043 12.2517 12.5028 12.0502 12.2543 12.0502H11.05V2.9502H12.2543C12.5028 2.9502 12.7043 2.74873 12.7043 2.5002C12.7043 2.25167 12.5028 2.0502 12.2543 2.0502H8.75432Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>` +
                  "2",
                content:
                  '<div data-gjs-type="text" class="H2">Heading level 2 here</div>',
              },
              {
                id: "h3",
                label:
                  `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75432 2.0502C8.50579 2.0502 8.30432 2.25167 8.30432 2.5002C8.30432 2.74873 8.50579 2.9502 8.75432 2.9502H9.94997V7.05004H5.04997V2.9502H6.25432C6.50285 2.9502 6.70432 2.74873 6.70432 2.5002C6.70432 2.25167 6.50285 2.0502 6.25432 2.0502H2.75432C2.50579 2.0502 2.30432 2.25167 2.30432 2.5002C2.30432 2.74873 2.50579 2.9502 2.75432 2.9502H3.94997V12.0502H2.75432C2.50579 12.0502 2.30432 12.2517 2.30432 12.5002C2.30432 12.7487 2.50579 12.9502 2.75432 12.9502H6.25432C6.50285 12.9502 6.70432 12.7487 6.70432 12.5002C6.70432 12.2517 6.50285 12.0502 6.25432 12.0502H5.04997V7.95004H9.94997V12.0502H8.75432C8.50579 12.0502 8.30432 12.2517 8.30432 12.5002C8.30432 12.7487 8.50579 12.9502 8.75432 12.9502H12.2543C12.5028 12.9502 12.7043 12.7487 12.7043 12.5002C12.7043 12.2517 12.5028 12.0502 12.2543 12.0502H11.05V2.9502H12.2543C12.5028 2.9502 12.7043 2.74873 12.7043 2.5002C12.7043 2.25167 12.5028 2.0502 12.2543 2.0502H8.75432Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>` +
                  "3",
                content:
                  '<div data-gjs-type="text" class="H3">Heading level 3 here</div>',
              },
              {
                id: "text",
                label: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.94993 2.95002L3.94993 4.49998C3.94993 4.74851 3.74845 4.94998 3.49993 4.94998C3.2514 4.94998 3.04993 4.74851 3.04993 4.49998V2.50004C3.04993 2.45246 3.05731 2.40661 3.07099 2.36357C3.12878 2.18175 3.29897 2.05002 3.49993 2.05002H11.4999C11.6553 2.05002 11.7922 2.12872 11.8731 2.24842C11.9216 2.32024 11.9499 2.40682 11.9499 2.50002L11.9499 2.50004V4.49998C11.9499 4.74851 11.7485 4.94998 11.4999 4.94998C11.2514 4.94998 11.0499 4.74851 11.0499 4.49998V2.95002H8.04993V12.05H9.25428C9.50281 12.05 9.70428 12.2515 9.70428 12.5C9.70428 12.7486 9.50281 12.95 9.25428 12.95H5.75428C5.50575 12.95 5.30428 12.7486 5.30428 12.5C5.30428 12.2515 5.50575 12.05 5.75428 12.05H6.94993V2.95002H3.94993Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>`,
                content:
                  '<div data-gjs-type="text" class="text" data-gjs-droppable="false">Text here</div>',
              },
              {
                id: "link-button",
                label: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 5H13C13.5523 5 14 5.44772 14 6V9C14 9.55228 13.5523 10 13 10H2C1.44772 10 1 9.55228 1 9V6C1 5.44772 1.44772 5 2 5ZM0 6C0 4.89543 0.895431 4 2 4H13C14.1046 4 15 4.89543 15 6V9C15 10.1046 14.1046 11 13 11H2C0.89543 11 0 10.1046 0 9V6ZM4.5 6.75C4.08579 6.75 3.75 7.08579 3.75 7.5C3.75 7.91421 4.08579 8.25 4.5 8.25C4.91421 8.25 5.25 7.91421 5.25 7.5C5.25 7.08579 4.91421 6.75 4.5 6.75ZM6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75C7.91421 6.75 8.25 7.08579 8.25 7.5C8.25 7.91421 7.91421 8.25 7.5 8.25C7.08579 8.25 6.75 7.91421 6.75 7.5ZM10.5 6.75C10.0858 6.75 9.75 7.08579 9.75 7.5C9.75 7.91421 10.0858 8.25 10.5 8.25C10.9142 8.25 11.25 7.91421 11.25 7.5C11.25 7.08579 10.9142 6.75 10.5 6.75Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>`,
                attributes: { class: "gjs-blocks-button" },
                content: {
                  tagName: "a",
                  type: "link",
                  content: "Click me",
                  attributes: {
                    class: "button button-medium button-solid",
                    href: "https://example.com",
                    target: "_blank",
                  },
                },
              },
              // {
              //   id: "container",
              //   label: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 2H2.5C2.22386 2 2 2.22386 2 2.5V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>`,
              //   content:
              //     '<div class="container" data-gjs-droppable=".card" data-gjs-custom-name="container"></div>',
              // },
              {
                id: "section",
                label: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 2H2.5C2.22386 2 2 2.22386 2 2.5V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>`,
                content:
                  '<div class="section" data-gjs-droppable="true" data-gjs-custom-name="section"></div>',
              },
              // {
              //   id: "card",
              //   label: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>`,
              //   content:
              //     '<div class="card" data-gjs-droppable="true" data-gjs-draggable="true" data-gjs-custom-name="card">' +
              //     '<img width="272px" data-gjs-droppable="true" data-gjs-draggable="true" data-gjs-custom-name="image" height="272px" src="/images/ButtonImage.png"/>' +
              //     '<div data-gjs-type="text">Button component</div>' +
              //     '<div class="description" data-gjs-type="text">Widely used Button within UIs with 60% of adoption.</div>' +
              //     '<a class="button button-medium button-solid" data-gjs-custom-name="button" data-gjs-type="text">Read more</a>' +
              //     "</div>",
              // },
              {
                id: "code-block",
                label: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>`,
                content:
                  '<code data-gjs-custom-name="code-block" class="language-jsx code-block" data-gjs-type="text">npm i @radix-ui/react-icons</code>',
              },
              {
                id: "table_with_droppable_text",
                label:
                  '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 2H12.5C12.7761 2 13 2.22386 13 2.5V5H8V2ZM7 5V2H2.5C2.22386 2 2 2.22386 2 2.5V5H7ZM2 6V9H7V6H2ZM8 6H13V9H8V6ZM8 10H13V12.5C13 12.7761 12.7761 13 12.5 13H8V10ZM2 12.5V10H7V13H2.5C2.22386 13 2 12.7761 2 12.5ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>',
                content: `
                <table class="Table">
                  <tr>
                    <th data-gjs-droppable="true">
                      <div data-gjs-type="text" class="text" data-gjs-droppable="true">Header 1</div>
                    </th>
                    <th data-gjs-droppable="true">
                      <div data-gjs-type="text" class="text" data-gjs-droppable="true">Header 2</div>
                    </th>
                    <th data-gjs-droppable="true">
                      <div data-gjs-type="text" class="text" data-gjs-droppable="true">Header 3</div>
                    </th>
                  </tr>
                  <tr>
                    <td data-gjs-droppable="true">
                      <div data-gjs-type="text" class="text" data-gjs-droppable="true">Cell 1</div>
                    </td>
                    <td data-gjs-droppable="true">
                      <div data-gjs-type="text" class="text" data-gjs-droppable="true">Cell 2</div>
                    </td>
                    <td data-gjs-droppable="true">
                      <div data-gjs-type="text" class="text" data-gjs-droppable="true">Cell 3</div>
                    </td>
                  </tr>
                  <tr>
                    <td data-gjs-droppable="true">
                      <div data-gjs-type="text" class="text" data-gjs-droppable="true">Cell 4</div>
                    </td>
                    <td data-gjs-droppable="true">
                      <div data-gjs-type="text" class="text" data-gjs-droppable="true">Cell 5</div>
                    </td>
                    <td data-gjs-droppable="true">
                      <div data-gjs-type="text" class="text" data-gjs-droppable="true">Cell 6</div>
                    </td>
                  </tr>
                </table>
              `,
              },
            ],
          },

          // ...other GrapesJS initialization options
        });

        editorInstance.current.setComponents(grapesContent.components || []);
        editorInstance.current.setStyle(grapesContent.styles || []);
      }
      //
      //
      //
      //
      //
      // custom component settings
      editorInstance.current.on("component:selected", (component) => {
        const componentInfoContainer = document.querySelector(".componentInfo");
        // Clear the previous content
        ReactDOM.unmountComponentAtNode(componentInfoContainer);
        componentInfoContainer.innerHTML = "";

        // Check if the selected component is a Text component
        // if (component.is("text")) {
        //   // Create a label and input element for font size
        //   const labelFontSize = document.createElement("label");
        //   labelFontSize.innerText = "Font Size: ";
        //   const inputFontSize = document.createElement("input");
        //   inputFontSize.type = "number";
        //   inputFontSize.value = component.getStyle()["font-size"] || "";

        //   // Event listener to update the font size
        //   inputFontSize.addEventListener("input", (e) => {
        //     component.addStyle({ "font-size": `${e.target.value}px` });
        //   });

        //   // Append the label and input to the componentInfo container
        //   componentInfoContainer.appendChild(labelFontSize);
        //   componentInfoContainer.appendChild(inputFontSize);
        // }

        // if (component.is("iframe")) {
        //   // Set the initial value for the iframe URL
        //   setIframeUrl(component.get("src") || "");
        //   // Function to handle updating the iframe URL
        //   const handleInputChange = (event) => {
        //     const newUrl = event.target.value;
        //     setIframeUrl(newUrl);
        //   };

        //   // Function to handle the button click event
        //   const handleUpdateClick = () => {
        //     const newUrl = iframeUrl; // Get the current value from state
        //     component.addAttributes({ src: newUrl }); // Update iframe URL
        //   };

        //   // Render the custom Input component with a submit button
        //   ReactDOM.render(
        //     <div>
        //       <Input
        //         type="text"
        //         value={iframeUrl}
        //         onChange={handleInputChange} // Use handleInputChange for input change
        //         placeholder="Enter iframe URL"
        //         label="Iframe URL"
        //       />
        //       <Button onClick={handleUpdateClick}>Update</Button>
        //     </div>,
        //     componentInfoContainer
        //   );
        // }
        if (component.is("iframe")) {
          setShowComponentToolbar(true);

          // Create a label and input element for iframe URL
          const labelIframe = document.createElement("label");
          labelIframe.innerText = "Iframe URL: ";
          const inputIframe = document.createElement("input");
          inputIframe.type = "text";
          inputIframe.value = component.getAttributes()["src"] || "";

          // Event listener to update the iframe URL
          inputIframe.addEventListener("input", (e) => {
            component.addAttributes({ src: e.target.value });
          });

          // Append the label and input to the componentInfo container
          componentInfoContainer.appendChild(labelIframe);
          componentInfoContainer.appendChild(inputIframe);
        } else if (component.is("link") || component.get("type") === "link") {
          setShowComponentToolbar(true);

          // Create and append the href URL input for link/button
          const labelHref = document.createElement("label");
          labelHref.innerText = "URL: ";
          const inputHref = document.createElement("input");
          inputHref.type = "text";
          inputHref.value = component.getAttributes()["href"] || "";
          inputHref.addEventListener("input", (e) => {
            component.addAttributes({ href: e.target.value });
          });
          componentInfoContainer.appendChild(labelHref);
          componentInfoContainer.appendChild(inputHref);
        } else {
          setShowComponentToolbar(false);
        }
      });

      //
      //
      //
      //
      //
      // Add the 'clear-board' command
      editorInstance.current.Commands.add("clear-board", {
        run: clearBoard,
      });

      const updateHasContent = () => {
        const content = editorInstance.current.getComponents();
        setHasContent(content.length > 0);
      };

      // Add event listeners to update hasContent
      editorInstance.current.on("component:add", updateHasContent);
      editorInstance.current.on("component:update", updateHasContent);
      editorInstance.current.on("component:remove", updateHasContent);

      const injectCustomStyles = () => {
        if (!editorRef.current) return;
        const rteActions = document.querySelectorAll(
          ".gjs-rte-actionbar .gjs-rte-action"
        );

        rteActions.forEach((action) => {
          const title = action.getAttribute("title");

          switch (title) {
            case "Bold":
              action.innerHTML =
                '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.10505 12C4.70805 12 4.4236 11.912 4.25171 11.736C4.0839 11.5559 4 11.2715 4 10.8827V4.11733C4 3.72033 4.08595 3.43588 4.25784 3.26398C4.43383 3.08799 4.71623 3 5.10505 3C6.42741 3 8.25591 3 9.02852 3C10.1373 3 11.0539 3.98153 11.0539 5.1846C11.0539 6.08501 10.6037 6.81855 9.70327 7.23602C10.8657 7.44851 11.5176 8.62787 11.5176 9.48128C11.5176 10.5125 10.9902 12 9.27734 12C8.77742 12 6.42626 12 5.10505 12ZM8.37891 8.00341H5.8V10.631H8.37891C8.9 10.631 9.6296 10.1211 9.6296 9.29877C9.6296 8.47643 8.9 8.00341 8.37891 8.00341ZM5.8 4.36903V6.69577H8.17969C8.53906 6.69577 9.27734 6.35939 9.27734 5.50002C9.27734 4.64064 8.48047 4.36903 8.17969 4.36903H5.8Z" fill="currentColor"></path></svg>';
              break;
            case "Italic":
              action.innerHTML =
                '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.67494 3.50017C5.67494 3.25164 5.87641 3.05017 6.12494 3.05017H10.6249C10.8735 3.05017 11.0749 3.25164 11.0749 3.50017C11.0749 3.7487 10.8735 3.95017 10.6249 3.95017H9.00587L7.2309 11.05H8.87493C9.12345 11.05 9.32493 11.2515 9.32493 11.5C9.32493 11.7486 9.12345 11.95 8.87493 11.95H4.37493C4.1264 11.95 3.92493 11.7486 3.92493 11.5C3.92493 11.2515 4.1264 11.05 4.37493 11.05H5.99397L7.76894 3.95017H6.12494C5.87641 3.95017 5.67494 3.7487 5.67494 3.50017Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>';
              break;
            case "Link":
              action.innerHTML =
                '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.51194 3.00541C9.18829 2.54594 10.0435 2.53694 10.6788 2.95419C10.8231 3.04893 10.9771 3.1993 11.389 3.61119C11.8009 4.02307 11.9513 4.17714 12.046 4.32141C12.4633 4.95675 12.4543 5.81192 11.9948 6.48827C11.8899 6.64264 11.7276 6.80811 11.3006 7.23511L10.6819 7.85383C10.4867 8.04909 10.4867 8.36567 10.6819 8.56093C10.8772 8.7562 11.1938 8.7562 11.389 8.56093L12.0077 7.94221L12.0507 7.89929C12.4203 7.52976 12.6568 7.2933 12.822 7.0502C13.4972 6.05623 13.5321 4.76252 12.8819 3.77248C12.7233 3.53102 12.4922 3.30001 12.1408 2.94871L12.0961 2.90408L12.0515 2.85942C11.7002 2.508 11.4692 2.27689 11.2277 2.11832C10.2377 1.46813 8.94398 1.50299 7.95001 2.17822C7.70691 2.34336 7.47044 2.57991 7.1009 2.94955L7.058 2.99247L6.43928 3.61119C6.24401 3.80645 6.24401 4.12303 6.43928 4.31829C6.63454 4.51355 6.95112 4.51355 7.14638 4.31829L7.7651 3.69957C8.1921 3.27257 8.35757 3.11027 8.51194 3.00541ZM4.31796 7.14672C4.51322 6.95146 4.51322 6.63487 4.31796 6.43961C4.12269 6.24435 3.80611 6.24435 3.61085 6.43961L2.99213 7.05833L2.94922 7.10124C2.57957 7.47077 2.34303 7.70724 2.17788 7.95035C1.50265 8.94432 1.4678 10.238 2.11799 11.2281C2.27656 11.4695 2.50766 11.7005 2.8591 12.0518L2.90374 12.0965L2.94837 12.1411C3.29967 12.4925 3.53068 12.7237 3.77214 12.8822C4.76219 13.5324 6.05589 13.4976 7.04986 12.8223C7.29296 12.6572 7.52943 12.4206 7.89896 12.051L7.89897 12.051L7.94188 12.0081L8.5606 11.3894C8.75586 11.1941 8.75586 10.8775 8.5606 10.6823C8.36533 10.487 8.04875 10.487 7.85349 10.6823L7.23477 11.301C6.80777 11.728 6.6423 11.8903 6.48794 11.9951C5.81158 12.4546 4.95642 12.4636 4.32107 12.0464C4.17681 11.9516 4.02274 11.8012 3.61085 11.3894C3.19896 10.9775 3.0486 10.8234 2.95385 10.6791C2.53661 10.0438 2.54561 9.18863 3.00507 8.51227C3.10993 8.35791 3.27224 8.19244 3.69924 7.76544L4.31796 7.14672ZM9.62172 6.08558C9.81698 5.89032 9.81698 5.57373 9.62172 5.37847C9.42646 5.18321 9.10988 5.18321 8.91461 5.37847L5.37908 8.91401C5.18382 9.10927 5.18382 9.42585 5.37908 9.62111C5.57434 9.81637 5.89092 9.81637 6.08619 9.62111L9.62172 6.08558Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>';
              break;
            case "Underline":
              action.innerHTML =
                '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.00001 2.75C5.00001 2.47386 4.77615 2.25 4.50001 2.25C4.22387 2.25 4.00001 2.47386 4.00001 2.75V8.05C4.00001 9.983 5.56702 11.55 7.50001 11.55C9.43301 11.55 11 9.983 11 8.05V2.75C11 2.47386 10.7762 2.25 10.5 2.25C10.2239 2.25 10 2.47386 10 2.75V8.05C10 9.43071 8.88072 10.55 7.50001 10.55C6.1193 10.55 5.00001 9.43071 5.00001 8.05V2.75ZM3.49998 13.1001C3.27906 13.1001 3.09998 13.2791 3.09998 13.5001C3.09998 13.721 3.27906 13.9001 3.49998 13.9001H11.5C11.7209 13.9001 11.9 13.721 11.9 13.5001C11.9 13.2791 11.7209 13.1001 11.5 13.1001H3.49998Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>';
              break;
            case "Strike-through":
              action.innerHTML =
                '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.00003 3.25C5.00003 2.97386 4.77617 2.75 4.50003 2.75C4.22389 2.75 4.00003 2.97386 4.00003 3.25V7.10003H2.49998C2.27906 7.10003 2.09998 7.27912 2.09998 7.50003C2.09998 7.72094 2.27906 7.90003 2.49998 7.90003H4.00003V8.55C4.00003 10.483 5.56703 12.05 7.50003 12.05C9.43303 12.05 11 10.483 11 8.55V7.90003H12.5C12.7209 7.90003 12.9 7.72094 12.9 7.50003C12.9 7.27912 12.7209 7.10003 12.5 7.10003H11V3.25C11 2.97386 10.7762 2.75 10.5 2.75C10.2239 2.75 10 2.97386 10 3.25V7.10003H5.00003V3.25ZM5.00003 7.90003V8.55C5.00003 9.93071 6.11932 11.05 7.50003 11.05C8.88074 11.05 10 9.93071 10 8.55V7.90003H5.00003Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>';
              break;
            case "Wrap for style":
              action.innerHTML =
                '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.9 0.499976C13.9 0.279062 13.7209 0.0999756 13.5 0.0999756C13.2791 0.0999756 13.1 0.279062 13.1 0.499976V1.09998H12.5C12.2791 1.09998 12.1 1.27906 12.1 1.49998C12.1 1.72089 12.2791 1.89998 12.5 1.89998H13.1V2.49998C13.1 2.72089 13.2791 2.89998 13.5 2.89998C13.7209 2.89998 13.9 2.72089 13.9 2.49998V1.89998H14.5C14.7209 1.89998 14.9 1.72089 14.9 1.49998C14.9 1.27906 14.7209 1.09998 14.5 1.09998H13.9V0.499976ZM11.8536 3.14642C12.0488 3.34168 12.0488 3.65826 11.8536 3.85353L10.8536 4.85353C10.6583 5.04879 10.3417 5.04879 10.1465 4.85353C9.9512 4.65827 9.9512 4.34169 10.1465 4.14642L11.1464 3.14643C11.3417 2.95116 11.6583 2.95116 11.8536 3.14642ZM9.85357 5.14642C10.0488 5.34168 10.0488 5.65827 9.85357 5.85353L2.85355 12.8535C2.65829 13.0488 2.34171 13.0488 2.14645 12.8535C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L9.14646 5.14642C9.34172 4.95116 9.65831 4.95116 9.85357 5.14642ZM13.5 5.09998C13.7209 5.09998 13.9 5.27906 13.9 5.49998V6.09998H14.5C14.7209 6.09998 14.9 6.27906 14.9 6.49998C14.9 6.72089 14.7209 6.89998 14.5 6.89998H13.9V7.49998C13.9 7.72089 13.7209 7.89998 13.5 7.89998C13.2791 7.89998 13.1 7.72089 13.1 7.49998V6.89998H12.5C12.2791 6.89998 12.1 6.72089 12.1 6.49998C12.1 6.27906 12.2791 6.09998 12.5 6.09998H13.1V5.49998C13.1 5.27906 13.2791 5.09998 13.5 5.09998ZM8.90002 0.499976C8.90002 0.279062 8.72093 0.0999756 8.50002 0.0999756C8.2791 0.0999756 8.10002 0.279062 8.10002 0.499976V1.09998H7.50002C7.2791 1.09998 7.10002 1.27906 7.10002 1.49998C7.10002 1.72089 7.2791 1.89998 7.50002 1.89998H8.10002V2.49998C8.10002 2.72089 8.2791 2.89998 8.50002 2.89998C8.72093 2.89998 8.90002 2.72089 8.90002 2.49998V1.89998H9.50002C9.72093 1.89998 9.90002 1.72089 9.90002 1.49998C9.90002 1.27906 9.72093 1.09998 9.50002 1.09998H8.90002V0.499976Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>';
              break;
            // Add cases for other actions...
            default:
              // Default case when none of the above matches
              break;
          }
        });
        const iframe = editorRef.current.querySelector(".gjs-frame");

        if (iframe) {
          try {
            const iframeDocument =
              iframe.contentDocument || iframe.contentWindow.document;
            const styleEl = iframeDocument.createElement("style");
            styleEl.innerHTML = `
          .H1[data-gjs-type="text"] {
            min-height: 44px;
            line-height: 44px;
            text-wrap: wrap;
            font-size: 32px;
            color: var(--foreground-neutral) !important;
            margin-bottom: 16px;
            font-family: var(--font-accent);
            font-weight: bold;
            display: flex;
          }
          .H2[data-gjs-type="text"] {
            min-height: 36px;
            line-height: 36px;
            text-wrap: wrap;
            font-size: 28px;
            font-family: var(--font-accent);
            font-weight: bold;
            color: var(--foreground-neutral) !important;
            margin-bottom: 16px;
            display: flex;
          }
          .H3[data-gjs-type="text"] {
            min-height: 32px;
            line-height: 32px;
            text-wrap: wrap;
            font-size: 20px;
            font-family: var(--font-accent);
            font-weight: bold;
            color: var(--foreground-neutral) !important;
            margin-bottom: 16px;
            display: flex;
          }
          `;
            iframeDocument.head.appendChild(styleEl);
          } catch (error) {
            console.error("Error accessing iframe content:", error);
          }
        }
      };

      // Wait for GrapesJS to be fully loaded and then change the background
      setTimeout(injectCustomStyles, 1000); // Adjust timeout as needed

      // Check if the note has been published
      const isPublished = isNotePublished;
      if (isPublished) {
        setShowPreview(true);
      }

      editorInstance.current.on("component:add", (component) => {
        if (component.is("extended-card")) {
          setIsDialogOpen(true);
          extendedCardRef.current = component; // Update the ref here
        }
      });

      // Custom templates

      // Event listener for component selection
      editorInstance.current.on("component:selected", () => {
        const selectedComponents = editorInstance.current.getSelectedAll();
        setShowSaveTemplateButton(selectedComponents.length > 1);
      });

      // Event listener for component deselection
      editorInstance.current.on("component:deselected", () => {
        const selectedComponents = editorInstance.current.getSelectedAll();
        setShowSaveTemplateButton(selectedComponents.length > 1);
      });

      //
      //
      //
      //
      //
      const adjustIframeBodyHeight = () => {
        const iframe = editorRef.current?.querySelector(".gjs-frame");
        if (iframe && iframe.contentWindow) {
          const body = iframe.contentWindow.document.body;
          const newHeight = body.scrollHeight;
          setIframeBodyHeight(newHeight);
          // console.log(newHeight);
        }
      };

      if (editorInstance.current) {
        editorInstance.current.on("component:add", adjustIframeBodyHeight);
        editorInstance.current.on("component:update", adjustIframeBodyHeight);
        editorInstance.current.on("component:remove", adjustIframeBodyHeight); // Add this line
      }

      return () => {
        // Cleanup
        if (editorInstance.current) {
          editorInstance.current.destroy();
          editorInstance.current = null;
        }
      };
    },
    [isNotePublished]
  );

  //
  //
  //
  //
  //
  useEffect(() => {
    const fetchNotesContent = async () => {
      const token = localStorage.getItem("token");
      if (!token || !id) {
        console.error("Token is missing or project file ID is empty.");
        return;
      }

      try {
        const response = await axios.get(`${serverUrl}/api/notes/notes/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data) {
          const { content, _id, isPublished, creationDate } = response.data;
          const grapesContent =
            content.length > 0
              ? JSON.parse(content[0])
              : { components: [], styles: [] };
          initializeEditor(grapesContent);

          // setIsNotePublished(isPublished);
          setNoteId(_id);
          // onIdChange(_id);
          setIsNotePublished(isPublished);
          if (creationDate) {
            setIsNoteSaved(true);
          }
          setHasContent(true);
        } else {
          initializeEditor({ components: [], styles: [] });
          initializeEditorWithDefaultContent();
        }
      } catch (error) {
        console.error("Error fetching content:", error);
        initializeEditor({ components: [], styles: [] });
        initializeEditorWithDefaultContent();
      }
    };

    fetchNotesContent();
  }, [id, serverUrl, initializeEditor]);
  //
  //
  //
  //
  //
  const fetchPublicTemplates = useCallback(async () => {
    try {
      const response = await fetch(`${serverUrl}/api/templates/public`);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const templatesData = await response.json();
      setPublicTemplates(templatesData); // Set public templates
    } catch (error) {
      console.error("Error fetching public templates:", error);
    }
  }, [serverUrl]);
  //
  const fetchOrgTemplates = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("Token is missing.");
      return;
    }

    try {
      const response = await axios.get(
        `${serverUrl}/api/templates/org-specific`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status !== 200) {
        throw new Error("Failed to fetch organization templates");
      }
      setOrgTemplates(response.data); // Update state with fetched templates
    } catch (error) {
      console.error("Error fetching organization-specific templates:", error);
    }
  }, [serverUrl]);
  //
  // useEffect(() => {
  //   fetchPublicTemplates();
  //   fetchOrgTemplates();
  // }, [serverUrl, userOrg, fetchOrgTemplates]);

  useEffect(() => {
    fetchPublicTemplates();
    fetchOrgTemplates();
    // fetchOrgTemplates(serverUrl, setOrgTemplates);
  }, [fetchPublicTemplates, fetchOrgTemplates]);
  //
  //
  //
  //
  //

  // Add this function to handle the save template logic
  const handleSaveTemplateData = async (data) => {
    // Retrieve only the selected components
    const selectedComponents = editorInstance.current.getSelectedAll();

    // Serialize the selected components
    const serializedComponents = selectedComponents.map((component) => {
      if (component.getAttributes()["data-gjs-custom-name"] === "card") {
        // Special handling for card components
        return component.toHTML(); // or any other specific serialization logic for cards
      } else {
        // Standard HTML serialization for other components
        return component.toHTML();
      }
    });
    // Prepare the data object to be sent to the server
    const templateData = {
      image: data.image,
      isPublic: data.isPublic,
      title: data.title,
      author: currentUser._id,
      date: new Date().toISOString(), // or use data.date if it's already in the desired format
      organisation: currentUser.organisation,
      content: serializedComponents,
    };

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("Token is missing, authorization required.");
      return;
    }

    try {
      const response = await axios.post(
        `${serverUrl}/api/templates`,
        templateData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Handle response
      if (response.status === 200) {
        console.log("Template saved successfully");
        setIsSaveTemplateDialogOpen(false); // Close the dialog after saving
        setShowToastTemplate(true); // Show success toast
        setTimeout(() => setShowToastTemplate(false), 5000); // Hide the toast after 5 seconds
      } else {
        console.error("Failed to save template");
      }
    } catch (error) {
      console.error("Error saving template:", error);
    }
    fetchOrgTemplates(serverUrl, setOrgTemplates);
  };

  const handleSave = async (event) => {
    event.preventDefault();

    const token = localStorage.getItem("token");
    if (!token || !id) {
      console.error("Token is missing or project file ID is empty.");
      return;
    }

    if (editorInstance.current) {
      const components = editorInstance.current.getComponents();
      const styles = editorInstance.current.getStyle();
      const grapesJSContent = { components, styles };

      // Decide whether to create a new note or update an existing one
      let endpoint;
      let method;
      if (noteId) {
        // If noteId is available, update the existing note
        endpoint = `${serverUrl}/api/notes/update-note/${id}`;
        method = "PUT";
      } else {
        // If noteId is not available, create a new note
        endpoint = `${serverUrl}/api/notes/create-note`;
        method = "POST";
      }

      const payload = JSON.stringify({
        content: grapesJSContent,
        projectFile: id,
        author: currentUser._id,
        organisation: currentUser.organisation,
        project: projectId,
      });
      // Check payload size
      if (new Blob([payload]).size > 1048576) {
        // 1MB limit (change as needed)
        console.error("Payload is too large.");
        setShowFailedSaveToast(true);
        setTimeout(() => setShowFailedSaveToast(false), 3000);
        return;
      }

      try {
        const response = await fetch(endpoint, {
          method: method,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            // body: payload,
          },
          body: JSON.stringify({
            content: grapesJSContent,
            projectFile: id,
            author: currentUser._id,
            organisation: currentUser.organisation,
            project: projectId,
          }),
        });

        const responseData = await response.json();
        if (response.ok) {
          if (!noteId) {
            // Set the noteId state if a new note was created
            setNoteId(responseData.note._id);
          }
          setShowToast(true);
          setTimeout(() => setShowToast(false), 3000);
          setIsNoteSaved(true);
        } else {
          // Handle errors
          console.error("Failed to save note");
        }
      } catch (error) {
        console.error("Error saving note:", error);
      }
    }
  };

  const onCardSelected = (selectedItem) => {
    if (editorInstance.current) {
      if (selectedItem.cardType === "Color" && selectedItem.colorsURL) {
        fetch(selectedItem.colorsURL)
          .then((response) => response.text())
          .then((csvData) => {
            parse(csvData, {
              complete: (results) => {
                // Generate table HTML from CSV data
                const tableHtml = generateTableHtml(results.data);
                // Inject table HTML into GrapesJS editor
                editorInstance.current.addComponents(tableHtml);
              },
            });
          });
      } else {
        // Handling regular cards
        let content;
        if (selectedItem.type === "iframe") {
          // If it's an iframe selection
          content = `<iframe src="${selectedItem.src}" width="100%" height="300px"></iframe>`;
        } else if (selectedItem.content) {
          // If the selected item is a template
          content = selectedItem.content.slice().reverse().join("");
        } else {
          // Handling other regular cards
          const imageSrc = selectedItem.image || "/images/PlaceholderImage.svg";
          const descriptionPart = selectedItem.description
            ? `<div class="description" data-gjs-type="text">${selectedItem.description}</div>`
            : "";
          content = `
            <div class="card" data-gjs-droppable="true" data-gjs-draggable="true" data-gjs-custom-name="card">
              <img 
                width="272px" 
                data-gjs-droppable="true" 
                data-gjs-draggable="true" 
                data-gjs-custom-name="image" 
                height="272px" 
                src="${imageSrc}" />
              <div data-gjs-type="text">${selectedItem.title}</div>
              ${descriptionPart}
              <a class="button button-medium button-solid" data-gjs-custom-name="button" data-gjs-type="text">Read more</a>
            </div>
          `;
        }

        editorInstance.current.addComponents(content);
      }
    }
  };

  // Function to generate HTML table from CSV data
  const generateTableHtml = (csvData) => {
    let html = "<table class='Table colorTable'><tbody>";
    csvData.forEach((row, rowIndex) => {
      html += "<tr>";
      row.forEach((cell, cellIndex) => {
        if (rowIndex === 0) {
          // Header row
          html += `<th>${cell}</th>`;
        } else if (cell.startsWith("#")) {
          // Color cell
          html += `<td style="background-color: ${cell};">${cell}</td>`;
        } else {
          // Regular cell
          html += `<td>${cell}</td>`;
        }
      });
      html += "</tr>";
    });
    html += "</tbody></table>";
    return html;
  };

  const handlePreview = () => {
    // Ensure the refs have current values
    const organization = organizationRef.current;
    const projectTitle = projectTitleRef.current;
    const cardTitle = cardTitleRef.current;

    if (!organization || !projectTitle || !cardTitle) {
      console.error(organization);
      console.error(projectTitle);
      console.error(cardTitle);
      console.error("Missing organization, project title, or card title");
      return;
    }

    setNoteId(noteId);
    // ${projectTitle}
    const previewUrl = `/${organization}/${id}`;
    window.open(previewUrl, "_blank");
  };

  useEffect(() => {
    const detector = document.querySelector(".detector");
    const blocks = document.getElementById("blocks");
    const notesContainer = document.querySelector(".NotesContainer");

    const checkPosition = () => {
      const rect = detector.getBoundingClientRect();
      const containerRect = notesContainer.getBoundingClientRect();

      if (rect.top <= 16) {
        blocks.classList.add("FloatingBlocks");
        detector.classList.add("blocksHeight");
        blocks.style.position = "fixed";
        blocks.style.left = `${containerRect.left}px`;
      } else {
        blocks.classList.remove("FloatingBlocks");
        detector.classList.remove("blocksHeight");
        blocks.style.position = "";
        blocks.style.left = "";
      }
    };

    // Set animation delays for blocks
    const gjsBlocks = document.querySelectorAll(".gjs-block");
    let delay = 0;
    gjsBlocks.forEach((block) => {
      block.style.setProperty("--animation-delay", `${delay}ms`);
      delay += 100;
    });

    window.addEventListener("scroll", checkPosition);

    // Cleanup function to remove event listener
    return () => window.removeEventListener("scroll", checkPosition);
  }, []);

  //

  const clearBoard = () => {
    if (editorInstance.current) {
      editorInstance.current.setComponents([]);
      editorInstance.current.setStyle([]);
    }
  };

  // console.log(showAlertClearNotesDialog);

  fetch("./compiled.css?v.1.0.9")
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then((css) => {
      const iframe = document.querySelector(".gjs-frame");
      if (iframe) {
        const styleEl = document.createElement("style");
        styleEl.innerHTML = css;
        iframe.contentDocument.body.appendChild(styleEl);
      }
    })
    .catch((error) => {
      console.error("Error fetching compiled CSS:", error);
    });
  //

  //

  return (
    <Flex customClass="NotesContainer" direction={"column"}>
      <Toast
        showToast={showFailedSaveToast}
        setShowToast={setShowFailedSaveToast}
        headline="Oh noo!"
        text="Some of the assets are too heavy!"
        time={3000}
      />

      <Toast
        showToast={showToastTemplate}
        setShowToast={setShowToastTemplate} // Add this line
        headline="Success!"
        text="Template has been saved 🚀"
        time={3000}
        // showAgain={true}
        // onDismissForever={handleDismissForever}
      />

      <Toast
        showToast={showToast}
        setShowToast={setShowToast} // Add this line
        headline="Success!"
        text="Note has been saved 🚀"
        time={3000}
        // showAgain={true}
        // onDismissForever={handleDismissForever}
      />

      <Toast
        showToast={showToastPublished}
        setShowToast={setShowToastPublished} // Add this line
        headline="Success!"
        text="Note has been published 🚀"
        time={3000}
      />

      <DialogSaveTemplate
        onSave={handleSaveTemplateData}
        open={isSaveTemplateDialogOpen}
        onOpenChange={setIsSaveTemplateDialogOpen}
      />

      <AlertDialogCustom
        title="Clear Notes"
        description={"Are you sure you want to clear notes?"}
        cta="Yes, clear"
        onClick={clearBoard}
        isOpen={showAlertClearNotesDialog}
        onOpenChange={setShowAlertClearNotesDialog}
      />
      <Flex
        gap={100}
        align="center"
        style={{ marginBottom: "var(--size-200)" }}
      >
        <Heading level={4} weight="bold">
          Editing Notes for: {title}
        </Heading>
        {isNotePublished ? <Tag text="Published" /> : <Tag text="Draft" />}
      </Flex>

      <Flex justify={"between"} style={{ marginBottom: "var(--size-200)" }}>
        <Flex gap={100}>
          <Button onClick={handleSave}>Save Notes</Button>
          {/* <Button variant="outline">Import Template</Button> */}
          <Button variant="outline" onClick={() => setIsDialogOpen(true)}>
            Import Block
          </Button>
          {showSaveTemplateButton && (
            <Button
              variant="ghost"
              onClick={() => setIsSaveTemplateDialogOpen(true)}
            >
              Save Template
            </Button>
          )}
        </Flex>

        <Flex gap={100}>
          <Toggle onPressedChange={onToggleGrid} aria-label="Toggle grid lines">
            <BorderNoneIcon />
          </Toggle>
          <IconButton
            variant="danger"
            onClick={() => setShowAlertClearNotesDialog(true)}
          >
            <TrashIcon />
          </IconButton>
          {showPreview && <Button onClick={handlePreview}>Preview</Button>}
          {hasContent && isNoteSaved && (
            <DropdownMenu modal={false}>
              <DropdownMenu.Trigger asChild>
                <Button size="medium" variant="outline">
                  <UploadIcon />
                  Publish
                </Button>
              </DropdownMenu.Trigger>

              <DropdownMenu.Content sideOffset={4} side="bottom" align="end">
                <DropdownMenu.Item onClick={handlePublish}>
                  to custom domain
                </DropdownMenu.Item>
                <DropdownMenu.Item disabled>in GoogleDocs</DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu>
          )}
        </Flex>
      </Flex>
      <Separator />
      <Flex customClass={"detector"}></Flex>
      <Flex id="blocks" customClass="MyBlocks"></Flex>
      <Flex id="advancedBlocks"></Flex>
      <Flex
        style={{
          height: `calc(${iframeBodyHeight}px + var(--size-600)`,
          minHeight: "300px",
          // borderTop: "1px solid var(--border-neutral-subtle)",
          paddingTop: "var(--size-100)",
        }}
        direction={"column"}
      >
        <Flex
          customClass={`componentInfo ${
            showComponentToolbar ? "showToolbar" : ""
          }`}
        ></Flex>
        <div ref={editorRef}></div>
      </Flex>

      <DialogNotePublished
        open={showDialog}
        onOpenChange={setShowDialog}
        onPublish={onPublish}
        isNotePublished={isNotePublished}
      />
      <GrapesCardSelectionDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onSaveCardSelection={onCardSelected}
        editorInstance={editorInstance.current}
        selectedOrgProjects={selectedOrgProjects}
        userOrg={currentUser?.organisation?.name}
        //
        publicTemplates={publicTemplates}
        orgTemplates={orgTemplates}
      />
    </Flex>
  );
};

export default Notes;
